import styled from "styled-components";
import {GamePlayMobileHeaderTopLeftContainerBox} from "../../../boxes/top-section/game-play-mobile-header-top-left-container.box";

export const BottomSectionBox = styled(GamePlayMobileHeaderTopLeftContainerBox)`
    
`